var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/ld+json"}},[_vm._v("\n  "+_vm._s({
      "@context": "https://schema.org/",
      "@type": "Review",
      "itemReviewed": {
        "@type": "Product",
        "name": _vm.productName,
        "description": _vm.productDescription
      },
      "author": {
        "@type": "Person",
        "name": _vm.author
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": _vm.ratingValue,
        "bestRating": _vm.BEST_REVIEW_RATING,
        "worstRating": _vm.WORST_REVIEW_RATING
      },
      "reviewBody": _vm.reviewBody
    })+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }